import { AddUpsellOptionModel, UpsellTypes } from 'models/Basket';

export class UpsellModel {
    public type: UpsellTypes;
    public options: AddUpsellOptionModel[];
    public isDisabled: boolean = false;
}